import { CacheInterface } from '@/repository/manager/whereaboutsCheck/cache';

const cacheKey = `whereaboutsCheckResult`;

export type ResultCache = {
  load: (version: number) => undefined | WhereaboutsCheckResult;
  save: (result: WhereaboutsCheckResult, version: number) => void;
  clear: () => void;
};

type WhereaboutsCheckResultPersisted = {
  version: number;
} & WhereaboutsCheckResult;

export default function (cache: CacheInterface): ResultCache {
  return {
    load: (version: number): undefined | WhereaboutsCheckResult => {
      const cached = cache.load(cacheKey);
      if (!cached) {
        return undefined;
      }
      const { version: cachedVersion, checkNGChildren } = cached as WhereaboutsCheckResultPersisted;
      // バージョンが古い場合もなかったことにする
      if (cachedVersion < version) {
        return undefined;
      }
      return { checkNGChildren };
    },
    save: (result: WhereaboutsCheckResult, version: number) => {
      const persisted: WhereaboutsCheckResultPersisted = { ...result, version };
      cache.save(cacheKey, persisted);
    },
    clear: () => {
      cache.clear(cacheKey);
    },
  };
}
